import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"0.375rem","color":"var(--ch-black)","font-size":"var(--font-lg)","font-weight":"500"} }
const _hoisted_2 = { style: {"margin":"0","color":"var(--ch-border-grey)","font-size":"0.8125rem"} }

interface Props {
  title: string;
  description: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FormHeader',
  props: {
    title: {},
    description: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(__props.title), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.description), 1)
  ]))
}
}

})